import { amazonConnectApi, type CommerceSyncHealth } from '../api/amazonconnect';

const TTL_MS = 45_000;
const cache = new Map<string, { at: number; data: CommerceSyncHealth }>();
const inflight = new Map<string, Promise<CommerceSyncHealth | null>>();

/** One health GET per connection; Brief / KPIs / Overlay / Ops share it. */
export async function fetchCommerceHealth(connectionId: string): Promise<CommerceSyncHealth | null> {
  const id = connectionId.trim();
  if (!id) return null;
  const hit = cache.get(id);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.data;
  const pending = inflight.get(id);
  if (pending) return pending;
  const job = amazonConnectApi
    .commerceSyncHealth(id)
    .then((data) => {
      cache.set(id, { at: Date.now(), data });
      return data;
    })
    .catch(() => null)
    .finally(() => {
      inflight.delete(id);
    });
  inflight.set(id, job);
  return job;
}
